<template>
  <div class="pc-canvas">
    <transition name="splash">
      <div
        class="pc-splash"
        :style="{ opacity: preloadOpacity }"
        v-if="!pcappstarted"
      >
        {{ percentLoaded }}%
      </div>
    </transition>
    <!-- <div v-if="!pcappstarted" class="pc-splash">Loading</div> -->
    <!-- this is the main canvas for the pc app -->
    <canvas
      :style="{ display: pcappstarted ? 'block' : 'none' }"
      tabindex="0"
      onselectstart="return false;"
      ref="pccanvas"
      class="pc-canvas"
    ></canvas>
  </div>
</template>

<script>
import * as pc from "playcanvas";
import { mapState } from "vuex";

export default {
  name: "PlayCanvas",
  emits: {
    appCreated: null,
    appProgress: null,
  },
  props: {},
  data: () => {
    return {
      pcappstarted: false,
      //app: null,
      devices: {},
      errorMsg: "",
      percent_loaded: 0,
    };
  },
  computed: {
    ...mapState({
      activeScene: (state) => state.scenes.active,
    }),
    percentLoaded() {
      return Math.round(this.percent_loaded * 100.0);
    },
    preloadOpacity() {
      return 1.0 - this.percent_loaded;
    },
  },
  methods: {
    initApp(){
      //modules preloading if necessary (ammo, basis etc.)
      if (window.PRELOAD_MODULES.length > 0) {
        window.loadModules(window.PRELOAD_MODULES, window.ASSET_PREFIX, this.createApp.bind(this));
      } else {
        this.createApp();
      }
    },
    createApp() {
      //create the app
      try {
        this.createInputDevices();
        this.app = new pc.Application(this.$refs.pccanvas, {
          elementInput: this.devices.elementInput,
          keyboard: this.devices.keyboard,
          mouse: this.devices.mouse,
          gamepads: this.devices.gamepads,
          touch: this.devices.touch,
          graphicsDeviceOptions: window.CONTEXT_OPTIONS,
          assetPrefix: window.ASSET_PREFIX || "",
          scriptPrefix: window.SCRIPT_PREFIX || "",
          scriptsOrder: window.SCRIPTS || [],
        });
        this.$emit("appCreated", this.app);
        this.app.on(
          "start",
          function () {
            this.pcappstarted = true;
          }.bind(this)
        );
        this.app.on(
          "preload:progress",
          (p) => {
            this.$emit("appProgress", p);
            this.percent_loaded = p;
          },
          this
        );
        this.app.configure(
          window.CONFIG_FILENAME,
          function (err) {
            if (err) {
              this.errorMsg = err;
              return;
            }
            var self = this;
            setTimeout(function () {
              self.reflow();
              window.addEventListener("resize", self.reflow, false);
              window.addEventListener("orientationchange", self.reflow, false);
              self.app.preload(function (err) {
                if (err) {
                  self.errorMsg = err;
                  return;
                }
                self.app.loadScene(window.SCENE_PATH, function (err) {
                  if (err) {
                    self.errorMsg = err;
                  }
                  self.app.start();
                });
              });
            });
          }.bind(this)
        );
      } catch (e) {
        this.errorMsg = "error with webGL ";
      }
    },
    createInputDevices: function() {
      var canvas = this.$refs.pccanvas;
      this.devices = {
        elementInput: new pc.ElementInput(canvas, {
          useMouse: window.INPUT_SETTINGS.useMouse,
          useTouch: window.INPUT_SETTINGS.useTouch,
        }),
        keyboard: window.INPUT_SETTINGS.useKeyboard
          ? new pc.Keyboard(window)
          : null,
        mouse: window.INPUT_SETTINGS.useMouse ? new pc.Mouse(canvas) : null,
        gamepads: window.INPUT_SETTINGS.useGamepads ? new pc.GamePads() : null,
        touch:
          window.INPUT_SETTINGS.useTouch && pc.platform.touch
            ? new pc.TouchDevice(canvas)
            : null,
      };
    },
    
    reflow() {
      var canvas = this.$refs.pccanvas;
      this.app.resizeCanvas(canvas.width, canvas.height);
      canvas.style.width = "";
      canvas.style.height = "";
    },
  },
  mounted() {
    window.pc = pc;
  },
  // watch: {
  //   activeScene: function (n) {
  //     console.log("new active scene value!" + JSON.stringify(n));
  //     if (this.app) this.app.fire("scene:active:change", n.id);
  //   },
  // },
};
</script>

<style scoped>
.pc-canvas {
  width: 100%;
  height: 100%;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}
canvas:focus {
  outline: none;
}
.pc-splash {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: var(--pccanvas-splash-backgroundcolor, transparent);
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: var(--loading-font);
  font-size: var(--loading-font-size);
  color: var(--loading-color);
}
.splash-enter-active,
.splash-leave-active {
  transition: var(--splash-fade-duration);
}
.splash-enter-from,
.splash-leave-to {
  opacity: 0;
}
</style>
